module.exports = __webpack_public_path__ + "img/Lebanon.e47eb56e.png";